import { InfoCircleOutlined } from '@ant-design/icons'
import { Space, Typography } from 'antd'
import { MemberProps } from 'app/components/Core/convention'
import useTranslation from 'app/lib/hooks/useTranslation'
import { RecordTypeEnum } from 'app/queries'
import * as React from 'react'

type ExtraProps = {
  type?: 'danger'
}

type Props = MemberProps<Pick<ICategorySegment, 'minimumRentalDuration'>, ExtraProps>

const MinimumRentalTime: React.FC<Props> = ({ member, props: { type } = {} }) => {
  const { tCore } = useTranslation({
    scope: 'info',
    recordType: RecordTypeEnum.categorySegment
  })

  return (
    <Space>
      <InfoCircleOutlined className={type === 'danger' ? 'text-danger' : ''} />
      <Typography.Text type={type}>
        {tCore(
          { id: 'minimum_rental_duration' },
          {
            days: member.minimumRentalDuration
          }
        )}
      </Typography.Text>
    </Space>
  )
}

export default MinimumRentalTime
